<template>
  <AppAlert color="warning" icon="mdi:airplane">
    <span v-html="$tt('aerial_only')" />
  </AppAlert>
</template>